import React from 'react';
import PropTypes from 'prop-types';

import Notification from '~/src/components/notification/Notification';
import CommentIcon from '~/src/components/svg/action/SpeechBubble';
import ActivityButton from '~/src/components/activity/button/ActivityButton';
import Modal from '~/src/components/modal/Modal';

import {getContentUrl} from '~/src/utilities/helpers/link';
import {ButtonFormat} from '~/src/utilities/constants/formats.js';
import {Hashes} from '~/src/utilities/constants/hash.js';
import {withSitemapContext} from '~/src/components/context/SitemapContext';
import {pushRoute} from '~/src/utilities/helpers/router.js';
import {trackGtm} from '~/src/utilities/tracking/gtm';
import {GtmEvents} from '~/src/utilities/constants/tracking';
import initPolyglot from '~/src/utilities/libs/polyglot';

import i18nStrings from './CommentButton.i18n.json';
import {ColorScheme} from '~/src/utilities/constants/formats';

const getTranslation = initPolyglot(i18nStrings);

class CommentButton extends React.Component {
    static defaultProps = {
        activityCount: 0 // TODO pd-100 hardcoded to 0 until we have the number from feed
    };

    closeNotification = () => {
        this.setState({isFullscreen: false});
    };

    showNotification = () => {
        this.setState({isFullscreen: true});
    };

    handleClick = (event) => {
        event.preventDefault();

        if (this.props.isDisabled) {
            this.showNotification();
        } else {
            if (this.props.openCommentPage) {
                pushRoute(this.props.context.sitemap.all, getContentUrl(`comment/${this.props.metadataId.toString()}`));
            } else {
                pushRoute(this.props.context.sitemap.all, getContentUrl(this.props.metadataId.toString(), Hashes.COMMENT_SECTION));
            }
        }

        trackGtm(GtmEvents.INTERACTION, {
            interactionType: 'comment',
            interactionSource: this.props.source,
            contentId: this.props.metadataId
        });
    };

    constructor(props) {
        super(props);

        this.state = {
            isFullscreen: false
        };
    }

    render() {
        return (
            <React.Fragment>
                <ActivityButton
                    isDisabled={this.props.isDisabled}
                    activityCount={this.props.activityCount}
                    format={this.props.format}
                    colorScheme={this.props.colorScheme}
                    onClick={this.handleClick}
                    data-testid="ButtonComment"
                >
                    <CommentIcon title={getTranslation('title')} />
                </ActivityButton>

                {this.state.isFullscreen && (
                    <Modal>
                        <Notification onClose={this.closeNotification} message={getTranslation('commentingDisabledMessage')} />
                    </Modal>
                )}
            </React.Fragment>
        );
    }
}

const CommentButtonLoader = ({format}) => {
    return (
        <ActivityButton activityCount="-" format={format} data-testid="ButtonComment">
            <CommentIcon />
        </ActivityButton>
    );
};

if (process.env.NODE_ENV === 'development') {
    CommentButton.propTypes = {
        activityCount: PropTypes.number,
        metadataId: PropTypes.string.isRequired,
        bookmarkCount: PropTypes.number,
        isDisabled: PropTypes.bool,
        format: PropTypes.oneOf(Object.values(ButtonFormat)).isRequired,
        colorScheme: PropTypes.oneOf(Object.values(ColorScheme))
    };
}

export {CommentButtonLoader};

export default withSitemapContext(CommentButton);
